export const ConfettiSize = {
    SMALL: { number: 15, initialSpeed: 15 },
    MEDIUM: { number: 30, initialSpeed: 18 },
    LARGE: { number: 60, initialSpeed: 21 }
};
